export default "__VITE_ASSET__CdoAGVx8__"